export default __webpack_public_path__ + "static/media/498.869a4423.jpg";